export default "<h1> Games - Passenger Engagement </h1>\r\n<p>Compares the engagement of Games versus other media types. </p>\r\n";